var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"sidebar"}},[_c('div',{staticClass:"sidebar"},[_c('header',{staticClass:"sidebar__header",on:{"click":function($event){return _vm.goHome()}}},[(_vm.tenant === 'DOM')?_c('domuneo-logo'):_c('mylight-logo')],1),_c('div',{staticClass:"sidebar__content"},[_vm._t("default")],2),_c('footer',{staticClass:"sidebar__footer"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }